export default __webpack_public_path__ + "static/media/official_logo.a3e564b1.png";